import type { Phase } from '../../shared/types';

const LABELS: Record<Phase, string> = {
  setup: 'Setup',
  capture: 'Capture',
  react: 'React',
  cluster: 'Theme',
  schedule: 'Plan',
  shipped: 'Deck',
  archived: 'Archived',
};

const PROMPTS: Record<Phase, string> = {
  setup: 'Add a few people, then move to Capture.',
  capture: 'Drop in everything. One-liner ideas, links, screenshots.',
  react: 'Swipe right on what excites you. Left to pass. Up for a star.',
  cluster: 'Group ideas into themes. AI offers a starting point.',
  schedule: 'Generate a draft plan, then chat with the AI to shape it.',
  shipped: 'Share the interactive deck.',
  archived: 'Closed.',
};

export function phaseLabel(p: Phase): string {
  return LABELS[p];
}

export function phasePrompt(p: Phase): string {
  return PROMPTS[p];
}

export function phaseAccent(p: Phase): boolean {
  return p !== 'setup' && p !== 'archived' && p !== 'shipped';
}

export const ACTIVE_PHASES: Phase[] = ['capture', 'react', 'cluster', 'schedule'];
export const ALL_PHASES: Phase[] = [
  'setup',
  'capture',
  'react',
  'cluster',
  'schedule',
  'shipped',
  'archived',
];

export function nextPhase(p: Phase): Phase | null {
  const i = ALL_PHASES.indexOf(p);
  if (i < 0 || i >= ALL_PHASES.length - 1) return null;
  // Skip 'archived' as a "next" — it's a manual choice.
  if (ALL_PHASES[i + 1] === 'archived') return null;
  return ALL_PHASES[i + 1] ?? null;
}
